<script>
import { mapActions } from 'vuex';
import { result } from 'lodash';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import EmployeeBasicInfoForm from './components/EmployeeBasicInfoForm';
import History from '../history';

export default {
  name: 'EmployeeDetails',
  components: {
    EmployeeBasicInfoForm,
    History,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      employee: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/employee/show/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('employeeDetails', ['fetchEmployee', 'saveEmployee']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchEmployee(this.params.id)
        .then(({ data }) => {
          this.employee = data;
          this.updateTabTitle({ path: this.path, title: this.employee.username });
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      return this.saveEmployee(this.employee)
        .then(() => {
          this.showSuccessMessage('Mitarbeiter erfolgreich gespeichert!');
        })
        .catch(({ response }) => {
          const message = result(
            response,
            'data.data.error',
            'Mitarbeiter konnte nicht gespeichert werden. Bitte versuche es erneut!',
          );
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<template>
  <div class="material-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching employee information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>
      </v-toolbar>

      <v-form>
        <v-container fluid grid-list-lg pt-2 pa-0>
          <v-tabs v-model="activeTab" height="35" slider-color="black" color="amber">
            <v-tab ripple>Verantwortlicher</v-tab>
            <v-tab ripple>Historie</v-tab>

            <v-tab-item>
              <EmployeeBasicInfoForm :employee="employee"/>
            </v-tab-item>
            <v-tab-item>
              <History :domain="'employee'" :domain-id="employee.id" path="/history" />
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-form>
    </template>
  </div>
</template>

<style lang="scss">
.employee-detail {
  &-title {
    margin-bottom: 10px;
  }

  &-actions {
    margin: 5px 0;

    .v-btn:first-child {
      border-radius: 5px 0 0 5px;
    }

    .v-btn:last-child {
      border-radius: 0 5px 5px 0;
    }

    .v-btn + .v-btn {
      border-left: 1px solid #fff !important;
    }

    .v-btn {
      margin: 0;
      width: 35px;
      height: 35px;
      border-radius: 0px;
    }
  }

  &-tab {
    padding-top: 10px;

    &-title {
      margin-bottom: 10px;
    }
  }

  &-common-list {
    margin-top: 5px;
    .v-btn {
      margin: 0px;
      width: 30px;
      height: 30px;
    }

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        .v-btn {
          opacity: 1;
        }
      }

      .v-btn {
        opacity: 0;
      }
    }
  }

  .v-tabs {
    &__items {
      padding-bottom: 30px;
    }
  }

  .submit-button {
    margin-top: 20px;
  }
}
</style>
